import axios from 'axios';
import React, { useEffect } from 'react';
import { alertRef } from '../../../../App';
import Modal from '../../../../Components/Modal/Modal';
import { Button, Textarea } from '../../../../Components/StyledComponents';
import { convertCost } from '../../../../Utils/functions';
import ExtraFee from './ExtraFee';
import './Fee.scss';
import PriceFee from './PriceFee';

const Fee = () => {
    const [info, setInfo ] = React.useState({})//배달팁 정보
    const modalRef = React.useRef(null);
    const extraRef = React.useRef(null);

    useEffect(() => {
        getFeeInfo()
    },[])

    //배달팁 정보 get
    const getFeeInfo = () => {
        axios.get('/api/order/info/fee')
        .then((data) => {
            if(typeof data.data.OrderInfo !== 'undefined' )setInfo(data.data.OrderInfo)
        })
    }

    //주문 금액별 배달팁 수정
    const patchBaseFee = (val) => {
        axios.patch('/api/order/info/delivery_price', val)
        .then((data) => {
            if(data.status === 204){
                getFeeInfo()
                modalRef.current.closeModal();
                alertRef.current.showAlert({ title : '주문금액별 배달팁이 수정 되었어요.', isConfirm : true, confirmText : '확인', onConfirm : () => alertRef.current.hideAlert() })
            }
        })
        .catch(() => {
            alertRef.current.showAlert({ title : `다시 시도해 주세요.`, isConfirm : true, confirmText : '확인', onConfirm : () => alertRef.current.hideAlert() })
        })
    }

    //배달팁 거리 할증 수정
    const patchExtraFee = (val) => {
        axios.patch('/api/order/info/extra_fee',{
            DeliveryExtraFee : val
        })
        .then((data) => {
            if(data.status === 204){
                getFeeInfo()
                extraRef.current.closeModal();
                alertRef.current.showAlert({ title : '배달팁 거리 할증이 수정 되었어요.', isConfirm : true, confirmText : '확인', onConfirm : () => alertRef.current.hideAlert() })
            }
        })
        .catch(() => {
            alertRef.current.showAlert({ title : `다시 시도해 주세요.`, isConfirm : true, confirmText : '확인', onConfirm : () => alertRef.current.hideAlert() })
        })
    }

    return (
        <div className='fee'>
            <div className='info-box'>
                <div className='row between'>
                    <div>
                        <p className='info-box-title'>주문금액별 배달팁 설정</p>
                        <p className='info-sub-title'>주문 금액에 따른 배달팁을 설정해요.</p>
                    </div>
                    <div className='row'>
                        <Button variant='sub' small style={{ width : 88 }} onClick={() => modalRef.current.openModal() }>
                            수정하기
                        </Button>
                    </div>
                </div>

                <div className='header-divider' ></div>

                <div>
                    <p className='info-title'>최소 주문 금액</p>
                    {
                        typeof info.MinDeliveryPrice !== 'undefined' ?
                        <p className='info-text-black'>{convertCost(Object.keys(info).length > 0 ? info.MinDeliveryPrice : 0)}원 이상 주문시 배달팁 {convertCost(Object.keys(info).length > 0 ? info.DeliveryBaseFee : 0)}원</p>
                        :
                        <p className='info-text'>최소 주문금액을 설정해 주세요.</p>
                    }
                </div>
                <div className='divider' ></div>
                
                <div>
                    <p className='info-title'>추가 금액별 배달팁</p>
                    {
                        ( Object.keys(info).length > 0 && ( typeof info.DeliveryBaseFeeByPrice !== 'undefined') && Object.keys(info.DeliveryBaseFeeByPrice).length > 0 )?
                            info.DeliveryBaseFeeByPrice.length === 0 ?
                            <p className='info-text'>금액별 추가 배달팁을 설정해주세요.</p>
                            :
                            info.DeliveryBaseFeeByPrice.map((data,i) => {
                                return(
                                    <p key={i} className='info-text-black'>{convertCost(data.Price)}이상 주문시 {convertCost(data.BaseFee)}원</p>
                                )
                            })
                        :
                        <p className='info-text'>금액별 추가 배달팁을 설정해주세요.</p>
                    }
                </div>
                <div className='divider' ></div>
            </div>

            <div className='info-box'>
                <div className='row between'>
                    <div>
                        <p className='info-box-title'>배달팁 거리 할증</p>
                        <p className='info-sub-title'>배달 거리에 따른 배달팁을 설정해요.</p>
                    </div>
                    
                    <div className='row'>
                        <Button variant='sub' small style={{ width : 88 }} onClick={() => extraRef.current.openModal()}>
                            수정하기
                        </Button>
                    </div>
                </div>

                <div className='header-divider' ></div>

                <div>
                    <p className='info-title' style={{ width : 'auto' }}>거리별 추가 할증 배달팁</p>
                    {
                        (Object.keys(info).length > 0 && typeof info.DeliveryExtraFee !== 'undefined' && Object.keys(info.DeliveryExtraFee).length > 0) ?
                            info.DeliveryExtraFee.length === 0 ?
                            <p className='info-text'>거리별 추가 할증 배달팁을 설정해주세요</p>
                            :
                            info.DeliveryExtraFee.map((data,i) => {
                                return(
                                    <p key={i} className='info-text-black'>{convertCost(data.Distance)}이상 거리의 배달팁 {convertCost(data.ExtraFee)}원</p>
                                )
                            })
                        :
                        <p className='info-text'>거리별 추가 할증 배달팁을 설정해주세요</p>
                    }
                </div>
                <div className='divider' ></div>
            </div>

            <Modal ref={modalRef} contentContainer={{width : 568 }} isHeader title={'주문금액별 배달팁 설정하기'}>
                <PriceFee MinDelivery={info.MinDeliveryPrice} MinBaseFee={info.DeliveryBaseFee} DeliveryBaseFeeByPrice={info.DeliveryBaseFeeByPrice} patchBaseFee={patchBaseFee}/>
            </Modal>

            <Modal ref={extraRef} contentContainer={{width : 568}} isHeader title={'배달팁 거리 할증 설정하기'}>
                <ExtraFee DeliveryExtraFee={info.DeliveryExtraFee} patchExtraFee={patchExtraFee}/>
            </Modal>
        </div>
    )
}

export default Fee;